export interface FaceoffCircleProps {
  /** CSS size, e.g. a Tailwind size class. Defaults to 6rem. */
  className?: string;
}

/** Faceoff circle drawn with a red 2px stroke: empty states and the landing corner. Decorative. */
export function FaceoffCircle({ className = "size-24" }: FaceoffCircleProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 100 100"
      className={`shrink-0 ${className}`}
      focusable="false"
    >
      <circle cx="50" cy="50" r="46" className="fill-none stroke-red" strokeWidth="2" />
      <circle cx="50" cy="50" r="3.5" className="fill-red" />
      <path
        d="M50 4 V14 M50 86 V96 M4 50 H14 M86 50 H96"
        className="stroke-red"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
